export default "__VITE_ASSET__b1f342f0__"